export default "__VITE_ASSET__Bcyyaia___"